/* et-split-space.js - Ela Teila, 2026-10-15 (Rita, klaidu sarasas 25 punktas).
   Temos <split-lines> antrastes (pvz. kolekcijos pavadinimas ant nuotraukos)
   suskaido i eilutes ir eilutes sudeda be tarpo, todel Google mato
   "Laiko patikrintimezginiai". Cia tarp eiluciu idedamas tarpas (nematomas,
   nes eilutes yra atskiri blokai). Isvaizda nesikeicia.
   Grazinimas: istrinti <script> eilute is snippets/et-scroll-keep.liquid. */
(function () {
  function fix(el) {
    var c = el.children;
    for (var i = 1; i < c.length; i++) {
      var p = c[i].previousSibling;
      if (!(p && p.nodeType === 3)) el.insertBefore(document.createTextNode(' '), c[i]);
    }
  }
  function scan() {
    var list = document.querySelectorAll('split-lines');
    for (var i = 0; i < list.length; i++) {
      var el = list[i];
      fix(el);
      if (!el.etSpaceObs) {
        el.etSpaceObs = true;
        new MutationObserver(function (m) { fix(m[0].target); }).observe(el, { childList: true });
      }
    }
  }
  if (document.readyState !== 'loading') scan();
  else document.addEventListener('DOMContentLoaded', scan);
  window.addEventListener('load', scan);
})();
